import React from 'react';

export default function Header({ user, onLogout, onOpenHelp }) {
  return (
    <header className="app-header">
      <div className="header-title">
        <span className="header-logo">🐷</span>
        <span>Копилка 3.0</span>
      </div>
      <div className="header-right">
        <button className="header-help" onClick={onOpenHelp} title="Справка" aria-label="Справка">?</button>
        <a className="header-support" href="mailto:webneo@list.ru" title="Написать в поддержку" aria-label="Написать в поддержку">
          <svg viewBox="0 0 24 24" fill="currentColor"><path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/></svg>
        </a>
        <button className="header-profile" onClick={() => window.dispatchEvent(new Event('open:profile'))} title="Профиль" aria-label="Профиль">
          <svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 12c2.7 0 5-2.3 5-5s-2.3-5-5-5-5 2.3-5 5 2.3 5 5 5zm0 2c-3.3 0-10 1.7-10 5v2h20v-2c0-3.3-6.7-5-10-5z"/></svg>
        </button>
        <button className="header-logout" onClick={onLogout} title="Выйти" aria-label="Выйти">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
            <polyline points="16 17 21 12 16 7" />
            <line x1="21" y1="12" x2="9" y2="12" />
          </svg>
        </button>
      </div>
    </header>
  );
}
